import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Responsive from 'react-responsive';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/styles';
import { CssBaseline } from '@material-ui/core';
import TagManager from 'react-gtm-module';
import packageJson from '../package.json';

import DesktopLayout from './components/layout/desktop/DesktopLayout';
import SkeletonLayout from './components/layout/SkeletonLayout';

import MobileLayout from './components/layout/mobile/MobileLayout';
import LogoutModal from './components/views/authentication/LogoutModal';

import ModalConfirmationTicket from './components/views/mis-compras/components/report-issue-view/ModalConfirmation.jsx';
import ModalUpdatePersonalData from './components/views/mis-datos/components/personalDataForm/ModalUpdatePersonalData.jsx';

import { getCookie, setCookie } from './providers/Cookies';

import { MOBILE_WIDTH } from './constants/Layout';

import MainTheme from './muiTheme';
import ScrollToTop from './scrollToTop';

const version = packageJson.version;
const Version = () => <div style={{ display: 'none' }}>{version}</div>;

const Desktop = (props) => (
  <Responsive {...props} minWidth={MOBILE_WIDTH + 1} />
);
const Mobile = (props) => <Responsive {...props} maxWidth={MOBILE_WIDTH} />;

function App() {
  const loggedSituation = useSelector(
    (state) => state.authenticationReducer.userAuth,
  );

  const { openModalUpdatePersonalData } = useSelector(
    (state) => state.profileReducer,
  );

  const modalUpdatePersonalDataIsOpen = () =>
    getCookie('OPEN_MODAL_UPDATE_PERSONAL_DATA') || false;

  useEffect(() => {
    if (!openModalUpdatePersonalData)
      setCookie('OPEN_MODAL_UPDATE_PERSONAL_DATA', true);
  }, [openModalUpdatePersonalData]);

  return (
    <ThemeProvider theme={MainTheme}>
      <LogoutModal />
      {loggedSituation === 'must_in' && (
        <Router>
          <React.Fragment>
            <CssBaseline />
            <Version />
            <ScrollToTop />
            <Desktop>
              <DesktopLayout />
              <ModalConfirmationTicket />
              {!modalUpdatePersonalDataIsOpen() && <ModalUpdatePersonalData />}
            </Desktop>
            <Mobile>
              <MobileLayout />
              <ModalConfirmationTicket mobile />
              {!modalUpdatePersonalDataIsOpen() && (
                <ModalUpdatePersonalData mobile />
              )}
            </Mobile>
          </React.Fragment>
        </Router>
      )}
      {!loggedSituation && <SkeletonLayout />}
    </ThemeProvider>
  );
}

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_CODE,
};

TagManager.initialize(tagManagerArgs);

export default App;
